<template>
<transition name="fade-in">
    <div class="edit-profile-wrapper">
      <div class="user-info">

        <styled-input-layout key-index="profile-name-field"
                             title="이름 입력"
                             :value="name"
                             @input="updateName"
                             :callback="enterEvent"/>

        <styled-input-layout key-index="profile-phone-field"
                             title="휴대폰 번호 입력"
                             :value="phone"
                             @input="updatePhone"
                             :callback="enterEvent"/>

        <styled-input-layout key-index="profile-email-field"
                             title="이메일 주소 입력"
                             :value="email"
                             @input="updateEmail"
                             :callback="enterEvent"/>

      </div>

      <div class="button-group">
        <slot></slot>
      </div>
    </div>
</transition>
</template>

<script>
import StyledInputLayout from '@/spa/components/LayoutStyledInput';

export default {
  name: 'EditProfile',
  components: {
    StyledInputLayout,
  },
  props: {
    name: String,
    phone: String,
    email: String,
    enterEvent: Function,
  },
  methods: {
    updateName(value) {
      this.$emit('name', value);
    },
    updatePhone(value) {
      this.$emit('phone', value);
    },
    updateEmail(value) {
      this.$emit('email', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-profile-wrapper {
  position: absolute;
  width: 100%;

  .user-info {
    margin-top: 12px;

    div {
      font-size: 16px;
      margin-bottom: 6px;

      &.name {
        font-size: 20px;
        margin-bottom: 12px;
      }

      &.phone, &.email {
        color: $nd60;
      }
    }
  }

  .button-group {
    margin-top: 24px;

    button {
      font-size: 16px;
      padding: 14px 24px;
      border-radius: 4px;
      border: 1px solid $color_active_blue;

      &.edit-profile {
        color: $color_active_blue;
        background-color: transparent;
        margin-right: 16px;
      }

      &.reset-password {
        color: $color_white;
        background-color: $color_active_blue;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .edit-profile-wrapper {
    .button-group {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/profile/layouts/EditProfile.vue